import React, { useEffect, useState } from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { useAuth } from "../context/AuthContext";
import { Link } from "react-router-dom";
import { api } from "../lib/api";
import { Briefcase, ChatCircle, Star, ArrowRight, Plus } from "@phosphor-icons/react";
import CustomerDashboard from "./CustomerDashboard";
import WorkerDashboard from "./WorkerDashboard";

export default function Dashboard() {
  const { user } = useAuth();
  if (!user) return null;
  if (user.role === "worker") return <WorkerDashboard />;
  if (user.role === "admin") {
    return (
      <div className="min-h-screen bg-white">
        <Header />
        <div className="pt-24 pb-16 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-xs uppercase tracking-[0.2em] font-semibold text-slate-500 mb-2">Welcome</div>
          <h1 className="font-display text-4xl mb-6">Admin Console</h1>
          <Link to="/admin" className="inline-flex items-center gap-2 bg-slate-900 text-white px-5 py-3 font-semibold" data-testid="open-admin-btn">
            Open admin <ArrowRight size={16} />
          </Link>
        </div>
        <Footer />
      </div>
    );
  }
  return <CustomerDashboard />;
}
